import React from "react";

import VodacomLogoMobile from "./VodacomLogoMobile";
import VodacomLogoWeb from "./VodacomLogoWeb";

import "./svg.css";

export default (props) => {
  return (
    <React.Fragment>
      <div className="vodacom-logo-mobile">
        <VodacomLogoMobile />
      </div>
      <div className="vodacom-logo-web">
        <VodacomLogoWeb />
      </div>
    </React.Fragment>
  );
};
